// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__ohU0b","label":"styles_label__2lbkh","picture":"styles_picture__3nLAJ","title":"styles_title__1ZTZU"};